import db from "../db/database";
import { markForDelete, markForSync } from "./syncService";

// Servicio para manejar las operaciones relacionadas con los turnos

// Agregar un nuevo turno a la base de datos
export const addTurno = async (turno) => {
    try {
        // Verificar si ya existe un turno con el mismo nombre
        const existingTurno = await db.turnos
            .where("DescripcionTurno")
            .equals(turno.DescripcionTurno)
            .first();

        if (existingTurno) {
            throw new Error("Ya existe un turno con ese nombre");
        }

        // Agregar el turno a la base de datos
        const id = await db.turnos.add({
            DescripcionTurno: turno.DescripcionTurno,
            HorarioInicio: turno.HorarioInicio,
            HorarioFin: turno.HorarioFin || null, // Campo opcional
            No: turno.No || null, // Guardar el No de Business Central si existe
            createdAt: new Date(),
            pendingSync: 1, // Marcar como pendiente de sincronización
            lastModified: new Date(),
            deleted: false,
        });

        return { id, ...turno };
    } catch (error) {
        console.error("Error al agregar turno:", error);
        throw error;
    }
};

// Obtener todos los turnos
export const getAllTurnos = async () => {
    try {
        // Obtener solo turnos no marcados como eliminados
        const turnos = await db.turnos
            .filter((turno) => !turno.deleted)
            .toArray();
        return turnos;
    } catch (error) {
        console.error("Error al obtener turnos:", error);
        throw error;
    }
};

// Obtener un turno por ID local
export const getTurnoById = async (id) => {
    try {
        const turno = await db.turnos.get(id);
        if (!turno || turno.deleted) {
            throw new Error("Turno no encontrado");
        }
        return turno;
    } catch (error) {
        console.error(`Error al obtener turno con ID ${id}:`, error);
        throw error;
    }
};

// Obtener un turno por No de Business Central
export const getTurnoByNo = async (no) => {
    try {
        const turno = await db.turnos
            .where("No")
            .equals(no)
            .and((turno) => !turno.deleted)
            .first();

        if (!turno) {
            throw new Error("Turno no encontrado");
        }
        return turno;
    } catch (error) {
        console.error(`Error al obtener turno con No ${no}:`, error);
        throw error;
    }
};

// Actualizar un turno existente
export const updateTurno = async (id, turnoData) => {
    try {
        const turno = await db.turnos.get(id);
        if (!turno || turno.deleted) {
            throw new Error("Turno no encontrado");
        }

        // Conservar el No existente si no se proporciona uno nuevo
        if (!turnoData.No && turno.No) {
            turnoData.No = turno.No;
        }

        // Actualizar el turno
        await db.turnos.update(id, {
            ...turnoData,
            lastModified: new Date(),
        });

        // Marcar como pendiente de sincronización
        await markForSync("turnos", id);

        return await getTurnoById(id);
    } catch (error) {
        console.error(`Error al actualizar turno con ID ${id}:`, error);
        throw error;
    }
};

// Eliminar un turno
export const deleteTurno = async (id) => {
    try {
        const turno = await db.turnos.get(id);
        if (!turno) {
            throw new Error("Turno no encontrado");
        }

        // Marcar como eliminado y pendiente de sincronización
        await markForDelete("turnos", id);

        return true;
    } catch (error) {
        console.error(`Error al eliminar turno con ID ${id}:`, error);
        throw error;
    }
}; 